import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// tslint:disable max-line-length
// tslint:disable no-namespace
// tslint:disable max-classes-per-file
// tslint:disable trailing-comma
// tslint:disable no-string-literal
// tslint:disable no-shadowed-variable array-type
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
import * as ApolloReactHoc from '@apollo/client/react/hoc';
const defaultOptions = {};
/** The set of address detail types. */
export var AddressDetailType;
(function (AddressDetailType) {
    /** The address contains postal box details. */
    AddressDetailType["Postalbox"] = "POSTALBOX";
    /** The address could not be broken up into the relevant details. */
    AddressDetailType["Printformat"] = "PRINTFORMAT";
    /** The address is a street address. */
    AddressDetailType["Street"] = "STREET";
})(AddressDetailType || (AddressDetailType = {}));
export var ExportAccountTransactionsFormat;
(function (ExportAccountTransactionsFormat) {
    ExportAccountTransactionsFormat["Ofx"] = "OFX";
    ExportAccountTransactionsFormat["Qif"] = "QIF";
})(ExportAccountTransactionsFormat || (ExportAccountTransactionsFormat = {}));
export var FieldDataType;
(function (FieldDataType) {
    FieldDataType["Date"] = "DATE";
    FieldDataType["Flag"] = "FLAG";
    FieldDataType["Money"] = "MONEY";
    FieldDataType["Number"] = "NUMBER";
    FieldDataType["Text"] = "TEXT";
})(FieldDataType || (FieldDataType = {}));
export var FileType;
(function (FileType) {
    FileType["Document"] = "DOCUMENT";
    FileType["Documentfooter"] = "DOCUMENTFOOTER";
    FileType["Documentheader"] = "DOCUMENTHEADER";
    FileType["Image"] = "IMAGE";
    FileType["Logo"] = "LOGO";
    FileType["Marketingimage"] = "MARKETINGIMAGE";
    FileType["Profileimage"] = "PROFILEIMAGE";
    FileType["Resource"] = "RESOURCE";
    FileType["Signature"] = "SIGNATURE";
    FileType["Statement"] = "STATEMENT";
    FileType["Template"] = "TEMPLATE";
})(FileType || (FileType = {}));
export var IndueCardStatus;
(function (IndueCardStatus) {
    IndueCardStatus["Active"] = "ACTIVE";
    IndueCardStatus["Activeoff"] = "ACTIVEOFF";
    IndueCardStatus["Cardcreated"] = "CARDCREATED";
    IndueCardStatus["Closed"] = "CLOSED";
    IndueCardStatus["Damaged"] = "DAMAGED";
    IndueCardStatus["Lost"] = "LOST";
    IndueCardStatus["Ordered"] = "ORDERED";
    IndueCardStatus["Other"] = "OTHER";
    IndueCardStatus["Restricted"] = "RESTRICTED";
    IndueCardStatus["Stolen"] = "STOLEN";
})(IndueCardStatus || (IndueCardStatus = {}));
export var LoginV3AuthError;
(function (LoginV3AuthError) {
    /** The username or password is invalid */
    LoginV3AuthError["Invalidcredentials"] = "INVALIDCREDENTIALS";
    /** An MFA token is required but has not been provided */
    LoginV3AuthError["Mfarequired"] = "MFAREQUIRED";
    /** The provided MFA token is invalid */
    LoginV3AuthError["Mfatokeninvalid"] = "MFATOKENINVALID";
    /** The provided new password is invalid. Check the AuthErrorDescription field for more information */
    LoginV3AuthError["Newpasswordinvalid"] = "NEWPASSWORDINVALID";
    /** The password has expired */
    LoginV3AuthError["Passwordexpired"] = "PASSWORDEXPIRED";
    /** User logged in with a temp password and must change their password before proceeding. Provide a value to NewPassword field */
    LoginV3AuthError["Requirepasswordchange"] = "REQUIREPASSWORDCHANGE";
})(LoginV3AuthError || (LoginV3AuthError = {}));
export var MultiFactorResult;
(function (MultiFactorResult) {
    /** Supplied mfa request is incorrect, expired, or otherwise invalid */
    MultiFactorResult["Invalid"] = "INVALID";
    /** Mfa is not enabled for this profile */
    MultiFactorResult["Notenabled"] = "NOTENABLED";
    /** Mfa succeeded */
    MultiFactorResult["Success"] = "SUCCESS";
})(MultiFactorResult || (MultiFactorResult = {}));
export var NppPayIdType;
(function (NppPayIdType) {
    NppPayIdType["Aubn"] = "AUBN";
    NppPayIdType["Emal"] = "EMAL";
    NppPayIdType["Orgn"] = "ORGN";
    NppPayIdType["Teli"] = "TELI";
})(NppPayIdType || (NppPayIdType = {}));
export var NppStatusCode;
(function (NppStatusCode) {
    NppStatusCode["Acti"] = "ACTI";
    NppStatusCode["Disa"] = "DISA";
    NppStatusCode["Dreg"] = "DREG";
    NppStatusCode["Port"] = "PORT";
})(NppStatusCode || (NppStatusCode = {}));
/** How to Group values in a period eg available redraw over the next month by day. */
export var Period;
(function (Period) {
    Period["Day"] = "DAY";
    Period["Eachchange"] = "EACHCHANGE";
    Period["Month"] = "MONTH";
    Period["Single"] = "SINGLE";
    Period["Week"] = "WEEK";
})(Period || (Period = {}));
export var PreferredContactTime;
(function (PreferredContactTime) {
    PreferredContactTime["Afterhours"] = "AFTERHOURS";
    PreferredContactTime["Anytime"] = "ANYTIME";
    PreferredContactTime["Businesshours"] = "BUSINESSHOURS";
    PreferredContactTime["Morning"] = "MORNING";
    PreferredContactTime["Never"] = "NEVER";
})(PreferredContactTime || (PreferredContactTime = {}));
export var PreferredCorrespondanceType;
(function (PreferredCorrespondanceType) {
    PreferredCorrespondanceType["Email"] = "EMAIL";
    PreferredCorrespondanceType["Mail"] = "MAIL";
    PreferredCorrespondanceType["Phone"] = "PHONE";
    PreferredCorrespondanceType["Sms"] = "SMS";
})(PreferredCorrespondanceType || (PreferredCorrespondanceType = {}));
export var PrivacyLevel;
(function (PrivacyLevel) {
    PrivacyLevel["Private"] = "PRIVATE";
    PrivacyLevel["Public"] = "PUBLIC";
    PrivacyLevel["Restricted"] = "RESTRICTED";
})(PrivacyLevel || (PrivacyLevel = {}));
/** Method to determine when to stop the recurrence */
export var RecurrenceEndEnum;
(function (RecurrenceEndEnum) {
    RecurrenceEndEnum["Bydate"] = "BYDATE";
    RecurrenceEndEnum["Never"] = "NEVER";
    RecurrenceEndEnum["Numberofocurrences"] = "NUMBEROFOCURRENCES";
    RecurrenceEndEnum["Once"] = "ONCE";
})(RecurrenceEndEnum || (RecurrenceEndEnum = {}));
export var TaskFrequencyPeriod;
(function (TaskFrequencyPeriod) {
    TaskFrequencyPeriod["Annually"] = "ANNUALLY";
    TaskFrequencyPeriod["Daily"] = "DAILY";
    TaskFrequencyPeriod["Dayofmonth"] = "DAYOFMONTH";
    TaskFrequencyPeriod["Firstofmonth"] = "FIRSTOFMONTH";
    TaskFrequencyPeriod["Fortnightly"] = "FORTNIGHTLY";
    TaskFrequencyPeriod["Lastofmonth"] = "LASTOFMONTH";
    TaskFrequencyPeriod["Monthly"] = "MONTHLY";
    TaskFrequencyPeriod["Once"] = "ONCE";
    TaskFrequencyPeriod["Quarterly"] = "QUARTERLY";
    TaskFrequencyPeriod["Quarterlyfinancialyear"] = "QUARTERLYFINANCIALYEAR";
    TaskFrequencyPeriod["Schedule"] = "SCHEDULE";
    TaskFrequencyPeriod["Sixmonthly"] = "SIXMONTHLY";
    TaskFrequencyPeriod["Weekday"] = "WEEKDAY";
    TaskFrequencyPeriod["Weekly"] = "WEEKLY";
})(TaskFrequencyPeriod || (TaskFrequencyPeriod = {}));
export var ToDoItemState;
(function (ToDoItemState) {
    ToDoItemState["Cancelled"] = "CANCELLED";
    ToDoItemState["Completed"] = "COMPLETED";
    ToDoItemState["Completedunsuccessfully"] = "COMPLETEDUNSUCCESSFULLY";
    ToDoItemState["Created"] = "CREATED";
    ToDoItemState["Suspended"] = "SUSPENDED";
    ToDoItemState["Takenup"] = "TAKENUP";
})(ToDoItemState || (ToDoItemState = {}));
export const UpdatePendingAccountFundsTransfersFragmentFragmentDoc = gql `
    fragment updatePendingAccountFundsTransfersFragment on Account {
  __typename
  Id
  PendingAccountFundsTransfers {
    Id
    ApplicationInstance
    ReceiptNumber
    AccountId
    TransferType
    TaskId
    TransferTypeDescription
    StartingOn
    Frequency
    FurtherNotice
    EndingOn
    FromAccountId
    FromAccountDescription
    ToAccountId
    ToAccountDescription
    Billercode
    BillerName
    CustomerReferenceNumber
    Amount
    RegularPayment
    NextScheduledDate
    DepositDescription
    WithdrawalDescription
    NumberOfTimes
    SpecifiedDate
  }
}
    `;
export const AccountByIdOrNumberDocument = gql `
    query accountByIdOrNumber($idOrNumber: String!) {
  accountByIdOrNumber(idOrNumber: $idOrNumber) {
    Id
    Number
    Description
    DisplayOrder
    InstrumentId
    LegacyNumber
    ProductType
    CurrentBalance
    Redraw
    ArrearsBalance
    InterestType
    CardAccount
    CardAvailable
    MonthlyInstalment
    NextInstalmentDue
    OffsetAccount
    BpayNumber
    BillerCode
    Rate
    RemainingDisbursementAmount
    IsCashAccount
    IsNonMaturing
    DisableDisbursements
    Transactions {
      Id
      SequenceNumber
      TransactionNumber
      Processed
      Effective
      EffectiveDate
      TransactionType
      StatementText
      Increase
      Decrease
      Balance
      Note
      WasReversed
      WasDishonoured
      WasBackedOut
      WasWaived
      AppearsOnStatement
      CreatedOn
      IsPending
      BatchPaymentId
    }
    Statements {
      Id
      Number
      InstrumentId
      AccountNumber
      AccountId
      PartyId
      ProcessedDate
      PeriodFrom
      PeriodTo
      FileId
      Filename
      Type
      AdHoc
    }
    Cards {
      Id
      Number
      HolderRelationship
      State
      ExpiryDate
      Type
      NameOnCard
    }
    CurrentUserAccountAuthority {
      Id
      BPay
      Operate
      InterAccount
      DirectDebit
      PayAnyone
      Redraw
      View
    }
  }
}
    `;
export const AccountByIdOrNumberComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: AccountByIdOrNumberDocument, ...props }));
export function withAccountByIdOrNumber(operationOptions) {
    return ApolloReactHoc.withQuery(AccountByIdOrNumberDocument, {
        alias: 'accountByIdOrNumber',
        ...operationOptions
    });
}
;
/**
 * __useAccountByIdOrNumberQuery__
 *
 * To run a query within a React component, call `useAccountByIdOrNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountByIdOrNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountByIdOrNumberQuery({
 *   variables: {
 *      idOrNumber: // value for 'idOrNumber'
 *   },
 * });
 */
export function useAccountByIdOrNumberQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(AccountByIdOrNumberDocument, options);
}
export function useAccountByIdOrNumberLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(AccountByIdOrNumberDocument, options);
}
export function useAccountByIdOrNumberSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(AccountByIdOrNumberDocument, options);
}
export const ChangeAccountDescriptionDocument = gql `
    mutation ChangeAccountDescription($input: ChangeAccountDescriptionInput!) {
  changeAccountDescription(input: $input) {
    Code
    Message
    Success
    Data {
      Id
      Description
    }
  }
}
    `;
export const ChangeAccountDescriptionComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: ChangeAccountDescriptionDocument, ...props }));
export function withChangeAccountDescription(operationOptions) {
    return ApolloReactHoc.withMutation(ChangeAccountDescriptionDocument, {
        alias: 'changeAccountDescription',
        ...operationOptions
    });
}
;
/**
 * __useChangeAccountDescriptionMutation__
 *
 * To run a mutation, you first call `useChangeAccountDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeAccountDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeAccountDescriptionMutation, { data, loading, error }] = useChangeAccountDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeAccountDescriptionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ChangeAccountDescriptionDocument, options);
}
export const InstrumentAuthorityAccountsDocument = gql `
    query instrumentAuthorityAccounts($account: String!, $date: DateTime) {
  instrumentByAccount(account: {Id: $account}) {
    Id
    Accounts {
      Id
      Number
      Description
      Redraw
      CurrentBalance
      CurrentUserAccountAuthority {
        Id
        BPay
        Operate
        InterAccount
        DirectDebit
        PayAnyone
        Redraw
        View
      }
    }
  }
  accountLimits(
    accountId: $account
    filter: {DateRange: {From: $date, To: $date}}
  ) {
    Id
    EffectiveDate
    Limits {
      DailyRedrawLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyRedrawLimit {
        CurrencyCode
        Amount
      }
      DailyPayAnyoneLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyPayAnyoneLimit {
        CurrencyCode
        Amount
      }
      DailyBPayLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyBPayLimit {
        CurrencyCode
        Amount
      }
    }
  }
}
    `;
export const InstrumentAuthorityAccountsComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: InstrumentAuthorityAccountsDocument, ...props }));
export function withInstrumentAuthorityAccounts(operationOptions) {
    return ApolloReactHoc.withQuery(InstrumentAuthorityAccountsDocument, {
        alias: 'instrumentAuthorityAccounts',
        ...operationOptions
    });
}
;
/**
 * __useInstrumentAuthorityAccountsQuery__
 *
 * To run a query within a React component, call `useInstrumentAuthorityAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstrumentAuthorityAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstrumentAuthorityAccountsQuery({
 *   variables: {
 *      account: // value for 'account'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useInstrumentAuthorityAccountsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(InstrumentAuthorityAccountsDocument, options);
}
export function useInstrumentAuthorityAccountsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(InstrumentAuthorityAccountsDocument, options);
}
export function useInstrumentAuthorityAccountsSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(InstrumentAuthorityAccountsDocument, options);
}
export const BpayBillerHistoryDocument = gql `
    query bpayBillerHistory {
  userSession {
    Id
    Party {
      Id
      BpayBillerHistory {
        Id
        Billercode
        BillerDescription
        BillerName
        CustomerReferenceNumber
        HasPendingTransfer
      }
    }
  }
}
    `;
export const BpayBillerHistoryComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: BpayBillerHistoryDocument, ...props }));
export function withBpayBillerHistory(operationOptions) {
    return ApolloReactHoc.withQuery(BpayBillerHistoryDocument, {
        alias: 'bpayBillerHistory',
        ...operationOptions
    });
}
;
/**
 * __useBpayBillerHistoryQuery__
 *
 * To run a query within a React component, call `useBpayBillerHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBpayBillerHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBpayBillerHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBpayBillerHistoryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(BpayBillerHistoryDocument, options);
}
export function useBpayBillerHistoryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(BpayBillerHistoryDocument, options);
}
export function useBpayBillerHistorySuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(BpayBillerHistoryDocument, options);
}
export const GetAccountByFundsTransferIdDocument = gql `
    query getAccountByFundsTransferId($id: Uuid!) {
  accountByFundsTransferId(id: $id) {
    Id
    ProductType
    PendingAccountFundsTransfers {
      Id
      Amount
      BillerName
      ReceiptNumber
      FromAccountDescription
      ToAccountDescription
      StartingOn
      DepositDescription
      CreatedOn
      RegularPayment
    }
  }
}
    `;
export const GetAccountByFundsTransferIdComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: GetAccountByFundsTransferIdDocument, ...props }));
export function withGetAccountByFundsTransferId(operationOptions) {
    return ApolloReactHoc.withQuery(GetAccountByFundsTransferIdDocument, {
        alias: 'getAccountByFundsTransferId',
        ...operationOptions
    });
}
;
/**
 * __useGetAccountByFundsTransferIdQuery__
 *
 * To run a query within a React component, call `useGetAccountByFundsTransferIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountByFundsTransferIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountByFundsTransferIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountByFundsTransferIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAccountByFundsTransferIdDocument, options);
}
export function useGetAccountByFundsTransferIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAccountByFundsTransferIdDocument, options);
}
export function useGetAccountByFundsTransferIdSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAccountByFundsTransferIdDocument, options);
}
export const StopPendingFundsTransferDocument = gql `
    mutation stopPendingFundsTransfer($input: StopPendingFundsTransferInput!) {
  stopPendingFundsTransfer(input: $input) {
    Code
    Success
    Message
    clientMutationId
    FundsTransfer {
      __typename
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      SpecifiedDate
    }
  }
}
    `;
export const StopPendingFundsTransferComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: StopPendingFundsTransferDocument, ...props }));
export function withStopPendingFundsTransfer(operationOptions) {
    return ApolloReactHoc.withMutation(StopPendingFundsTransferDocument, {
        alias: 'stopPendingFundsTransfer',
        ...operationOptions
    });
}
;
/**
 * __useStopPendingFundsTransferMutation__
 *
 * To run a mutation, you first call `useStopPendingFundsTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopPendingFundsTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopPendingFundsTransferMutation, { data, loading, error }] = useStopPendingFundsTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStopPendingFundsTransferMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(StopPendingFundsTransferDocument, options);
}
export const CreateBpayBillerDocument = gql `
    mutation createBpayBiller($input: CreateBpayBillerInput!) {
  createBpayBiller(input: $input) {
    Code
    Success
    Message
    clientMutationId
    NewBpayBiller {
      Id
      Billercode
      BillerDescription
      BillerName
      CustomerReferenceNumber
      HasPendingTransfer
    }
  }
}
    `;
export const CreateBpayBillerComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: CreateBpayBillerDocument, ...props }));
export function withCreateBpayBiller(operationOptions) {
    return ApolloReactHoc.withMutation(CreateBpayBillerDocument, {
        alias: 'createBpayBiller',
        ...operationOptions
    });
}
;
/**
 * __useCreateBpayBillerMutation__
 *
 * To run a mutation, you first call `useCreateBpayBillerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBpayBillerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBpayBillerMutation, { data, loading, error }] = useCreateBpayBillerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBpayBillerMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateBpayBillerDocument, options);
}
export const DeleteBpayPartyBillerDocument = gql `
    mutation deleteBpayPartyBiller($input: DeleteBpayPartyBillerInput!) {
  deleteBpayPartyBiller(input: $input) {
    Code
    Success
    Message
    clientMutationId
    PartyBillerHistoryId
  }
}
    `;
export const DeleteBpayPartyBillerComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: DeleteBpayPartyBillerDocument, ...props }));
export function withDeleteBpayPartyBiller(operationOptions) {
    return ApolloReactHoc.withMutation(DeleteBpayPartyBillerDocument, {
        alias: 'deleteBpayPartyBiller',
        ...operationOptions
    });
}
;
/**
 * __useDeleteBpayPartyBillerMutation__
 *
 * To run a mutation, you first call `useDeleteBpayPartyBillerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBpayPartyBillerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBpayPartyBillerMutation, { data, loading, error }] = useDeleteBpayPartyBillerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBpayPartyBillerMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteBpayPartyBillerDocument, options);
}
export const TransferLimitValidationDocument = gql `
    query transferLimitValidation($accountId: String, $date: DateTime) {
  accountLimits(
    accountId: $accountId
    filter: {DateRange: {From: $date, To: $date}}
  ) {
    EffectiveDate
    Id
    Limits {
      RemainingDailyRedrawLimit {
        Amount
        CurrencyCode
      }
      RemainingDailyPayAnyoneLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyBPayLimit {
        CurrencyCode
        Amount
      }
    }
  }
  accountByIdOrNumber(idOrNumber: $accountId) {
    Id
    Redraw
    IsCashAccount
  }
}
    `;
export const TransferLimitValidationComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: TransferLimitValidationDocument, ...props }));
export function withTransferLimitValidation(operationOptions) {
    return ApolloReactHoc.withQuery(TransferLimitValidationDocument, {
        alias: 'transferLimitValidation',
        ...operationOptions
    });
}
;
/**
 * __useTransferLimitValidationQuery__
 *
 * To run a query within a React component, call `useTransferLimitValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferLimitValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferLimitValidationQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTransferLimitValidationQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(TransferLimitValidationDocument, options);
}
export function useTransferLimitValidationLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(TransferLimitValidationDocument, options);
}
export function useTransferLimitValidationSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(TransferLimitValidationDocument, options);
}
export const AccountFundsTransfersDocument = gql `
    query accountFundsTransfers($accountIdOrNumber: String!, $transactionFilter: LookBackDaysInput = {Days: 90}) {
  accountByIdOrNumber(idOrNumber: $accountIdOrNumber) {
    Id
    Number
    Description
    DisplayOrder
    InstrumentId
    LegacyNumber
    ProductType
    CurrentBalance
    Redraw
    InterestType
    CardAccount
    MonthlyInstalment
    NextInstalmentDue
    IsCashAccount
    IsNonMaturing
    DisableDisbursements
    PendingAccountFundsTransfers {
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      NumberOfTimesAmount
      RemainingNumberOfTimes
      SpecifiedDate
      CreatedOn
    }
    ProcessedAccountFundsTransfers(filter: $transactionFilter) {
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      NumberOfTimesAmount
      RemainingNumberOfTimes
      SpecifiedDate
      CreatedOn
    }
    BankAccounts {
      AccountName
      Id
      BankIdentifierText
      BankIdentifierId
      AccountNumber
      Suffix
      Nominated
      HasDirectDebitAuthority
      HasDirectCreditAuthority
      IsPayAnyone
      BankName
    }
    AccountLimits {
      Id
      EffectiveDate
      Limits {
        DailyRedrawLimit {
          CurrencyCode
          Amount
        }
        RemainingDailyRedrawLimit {
          CurrencyCode
          Amount
        }
        DailyPayAnyoneLimit {
          CurrencyCode
          Amount
        }
        RemainingDailyPayAnyoneLimit {
          CurrencyCode
          Amount
        }
      }
    }
    CurrentUserAccountAuthority {
      Id
      BPay
      Operate
      InterAccount
      DirectDebit
      PayAnyone
      Redraw
      View
    }
  }
}
    `;
export const AccountFundsTransfersComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: AccountFundsTransfersDocument, ...props }));
export function withAccountFundsTransfers(operationOptions) {
    return ApolloReactHoc.withQuery(AccountFundsTransfersDocument, {
        alias: 'accountFundsTransfers',
        ...operationOptions
    });
}
;
/**
 * __useAccountFundsTransfersQuery__
 *
 * To run a query within a React component, call `useAccountFundsTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountFundsTransfersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountFundsTransfersQuery({
 *   variables: {
 *      accountIdOrNumber: // value for 'accountIdOrNumber'
 *      transactionFilter: // value for 'transactionFilter'
 *   },
 * });
 */
export function useAccountFundsTransfersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(AccountFundsTransfersDocument, options);
}
export function useAccountFundsTransfersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(AccountFundsTransfersDocument, options);
}
export function useAccountFundsTransfersSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(AccountFundsTransfersDocument, options);
}
export const CreatePayAnyoneBankAccountDocument = gql `
    mutation createPayAnyoneBankAccount($input: CreatePayAnyoneBankAccountInput!) {
  createPayAnyoneBankAccount(input: $input) {
    Code
    Success
    Message
    clientMutationId
    NewPartyBankAccount {
      Id
      BankAccount {
        Id
        AccountName
        AccountNumber
        BankIdentifierText
        BankName
        HasDirectCreditAuthority
        HasDirectDebitAuthority
        IsPayAnyone
      }
      Description
      DirectCredit
      DirectDebit
      IsUsedByTransfer
      PartyId
      PayAnyone
      Viewable
    }
  }
}
    `;
export const CreatePayAnyoneBankAccountComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: CreatePayAnyoneBankAccountDocument, ...props }));
export function withCreatePayAnyoneBankAccount(operationOptions) {
    return ApolloReactHoc.withMutation(CreatePayAnyoneBankAccountDocument, {
        alias: 'createPayAnyoneBankAccount',
        ...operationOptions
    });
}
;
/**
 * __useCreatePayAnyoneBankAccountMutation__
 *
 * To run a mutation, you first call `useCreatePayAnyoneBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePayAnyoneBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPayAnyoneBankAccountMutation, { data, loading, error }] = useCreatePayAnyoneBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePayAnyoneBankAccountMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreatePayAnyoneBankAccountDocument, options);
}
export const CurrentUserPartyBankAccountsDocument = gql `
    query currentUserPartyBankAccounts {
  userSession {
    Id
    Party {
      Id
      PartyBankAccounts {
        Id
        PartyId
        Viewable
        PayAnyone
        DirectCredit
        DirectDebit
        Bpay
        Description
        Deleted
        IsUsedByTransfer
        IsPayWayCustomer
        BankAccount {
          AccountName
          BankIdentifierId
          BankIdentifierText
          AccountNumber
          Suffix
          Nominated
          HasDirectDebitAuthority
          HasDirectCreditAuthority
          IsPayAnyone
          BankName
          Id
          HasPendingTransfer
        }
      }
    }
  }
}
    `;
export const CurrentUserPartyBankAccountsComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: CurrentUserPartyBankAccountsDocument, ...props }));
export function withCurrentUserPartyBankAccounts(operationOptions) {
    return ApolloReactHoc.withQuery(CurrentUserPartyBankAccountsDocument, {
        alias: 'currentUserPartyBankAccounts',
        ...operationOptions
    });
}
;
/**
 * __useCurrentUserPartyBankAccountsQuery__
 *
 * To run a query within a React component, call `useCurrentUserPartyBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPartyBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPartyBankAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPartyBankAccountsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(CurrentUserPartyBankAccountsDocument, options);
}
export function useCurrentUserPartyBankAccountsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(CurrentUserPartyBankAccountsDocument, options);
}
export function useCurrentUserPartyBankAccountsSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(CurrentUserPartyBankAccountsDocument, options);
}
export const DeletePartyBankAccountDocument = gql `
    mutation deletePartyBankAccount($input: DeletePartyBankAccountInput!) {
  deletePartyBankAccount(input: $input) {
    Code
    Success
    Message
    PartyBankAccountId
  }
}
    `;
export const DeletePartyBankAccountComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: DeletePartyBankAccountDocument, ...props }));
export function withDeletePartyBankAccount(operationOptions) {
    return ApolloReactHoc.withMutation(DeletePartyBankAccountDocument, {
        alias: 'deletePartyBankAccount',
        ...operationOptions
    });
}
;
/**
 * __useDeletePartyBankAccountMutation__
 *
 * To run a mutation, you first call `useDeletePartyBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartyBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartyBankAccountMutation, { data, loading, error }] = useDeletePartyBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePartyBankAccountMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeletePartyBankAccountDocument, options);
}
export const RequestPayAnyoneTransferDocument = gql `
    mutation requestPayAnyoneTransfer($input: RequestPayAnyoneTransferInput!) {
  requestPayAnyoneTransfer(input: $input) {
    Code
    Success
    Message
    clientMutationId
    FundsTransfer {
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      SpecifiedDate
    }
  }
}
    `;
export const RequestPayAnyoneTransferComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: RequestPayAnyoneTransferDocument, ...props }));
export function withRequestPayAnyoneTransfer(operationOptions) {
    return ApolloReactHoc.withMutation(RequestPayAnyoneTransferDocument, {
        alias: 'requestPayAnyoneTransfer',
        ...operationOptions
    });
}
;
/**
 * __useRequestPayAnyoneTransferMutation__
 *
 * To run a mutation, you first call `useRequestPayAnyoneTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPayAnyoneTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPayAnyoneTransferMutation, { data, loading, error }] = useRequestPayAnyoneTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPayAnyoneTransferMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RequestPayAnyoneTransferDocument, options);
}
export const InstrumentByAccountIdDocument = gql `
    query instrumentByAccountId($account: String!) {
  instrumentByAccount(account: {Id: $account}) {
    Id
    Accounts {
      Id
      Number
      Description
      Redraw
      CurrentBalance
      ProductType
      CurrentUserAccountAuthority {
        Id
        BPay
        Operate
        InterAccount
        DirectDebit
        PayAnyone
        Redraw
        View
      }
    }
  }
}
    `;
export const InstrumentByAccountIdComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: InstrumentByAccountIdDocument, ...props }));
export function withInstrumentByAccountId(operationOptions) {
    return ApolloReactHoc.withQuery(InstrumentByAccountIdDocument, {
        alias: 'instrumentByAccountId',
        ...operationOptions
    });
}
;
/**
 * __useInstrumentByAccountIdQuery__
 *
 * To run a query within a React component, call `useInstrumentByAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstrumentByAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstrumentByAccountIdQuery({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useInstrumentByAccountIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(InstrumentByAccountIdDocument, options);
}
export function useInstrumentByAccountIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(InstrumentByAccountIdDocument, options);
}
export function useInstrumentByAccountIdSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(InstrumentByAccountIdDocument, options);
}
export const AccountLimitDocument = gql `
    query accountLimit($accountId: String!, $date: DateTime) {
  accountLimits(
    accountId: $accountId
    filter: {DateRange: {From: $date, To: $date}}
  ) {
    Id
    EffectiveDate
    Limits {
      DailyRedrawLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyRedrawLimit {
        CurrencyCode
        Amount
      }
      DailyPayAnyoneLimit {
        CurrencyCode
        Amount
      }
      RemainingDailyPayAnyoneLimit {
        CurrencyCode
        Amount
      }
    }
  }
}
    `;
export const AccountLimitComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: AccountLimitDocument, ...props }));
export function withAccountLimit(operationOptions) {
    return ApolloReactHoc.withQuery(AccountLimitDocument, {
        alias: 'accountLimit',
        ...operationOptions
    });
}
;
/**
 * __useAccountLimitQuery__
 *
 * To run a query within a React component, call `useAccountLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountLimitQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAccountLimitQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(AccountLimitDocument, options);
}
export function useAccountLimitLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(AccountLimitDocument, options);
}
export function useAccountLimitSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(AccountLimitDocument, options);
}
export const BpayTransferRequestDocument = gql `
    mutation bpayTransferRequest($input: BpayTransferRequestInput!) {
  bpayTransferRequest(input: $input) {
    Code
    Success
    Message
    clientMutationId
    FundsTransfer {
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      SpecifiedDate
    }
    ValidationErrors {
      Code
      Message
    }
  }
}
    `;
export const BpayTransferRequestComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: BpayTransferRequestDocument, ...props }));
export function withBpayTransferRequest(operationOptions) {
    return ApolloReactHoc.withMutation(BpayTransferRequestDocument, {
        alias: 'bpayTransferRequest',
        ...operationOptions
    });
}
;
/**
 * __useBpayTransferRequestMutation__
 *
 * To run a mutation, you first call `useBpayTransferRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBpayTransferRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bpayTransferRequestMutation, { data, loading, error }] = useBpayTransferRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBpayTransferRequestMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(BpayTransferRequestDocument, options);
}
export const PartyPaymentLimitDocument = gql `
    mutation partyPaymentLimit($input: PartyPaymentLimitInput!) {
  setPartyPaymentLimit(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export const PartyPaymentLimitComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: PartyPaymentLimitDocument, ...props }));
export function withPartyPaymentLimit(operationOptions) {
    return ApolloReactHoc.withMutation(PartyPaymentLimitDocument, {
        alias: 'partyPaymentLimit',
        ...operationOptions
    });
}
;
/**
 * __usePartyPaymentLimitMutation__
 *
 * To run a mutation, you first call `usePartyPaymentLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartyPaymentLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partyPaymentLimitMutation, { data, loading, error }] = usePartyPaymentLimitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartyPaymentLimitMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(PartyPaymentLimitDocument, options);
}
export const RequestInterInstrumentTransferMutationDocument = gql `
    mutation RequestInterInstrumentTransferMutation($input: RequestInterInstrumentTransferInput!) {
  requestInterInstrumentTransfer(input: $input) {
    Code
    Success
    Message
    clientMutationId
    FundsTransfer {
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      SpecifiedDate
    }
  }
}
    `;
export const RequestInterInstrumentTransferMutationComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: RequestInterInstrumentTransferMutationDocument, ...props }));
export function withRequestInterInstrumentTransferMutation(operationOptions) {
    return ApolloReactHoc.withMutation(RequestInterInstrumentTransferMutationDocument, {
        alias: 'requestInterInstrumentTransferMutation',
        ...operationOptions
    });
}
;
/**
 * __useRequestInterInstrumentTransferMutationMutation__
 *
 * To run a mutation, you first call `useRequestInterInstrumentTransferMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestInterInstrumentTransferMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestInterInstrumentTransferMutationMutation, { data, loading, error }] = useRequestInterInstrumentTransferMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestInterInstrumentTransferMutationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RequestInterInstrumentTransferMutationDocument, options);
}
export const RequestPayAnyoneTransferMutationDocument = gql `
    mutation requestPayAnyoneTransferMutation($input: RequestPayAnyoneTransferInput!) {
  requestPayAnyoneTransfer(input: $input) {
    Code
    Success
    Message
    clientMutationId
    FundsTransfer {
      Id
      ApplicationInstance
      ReceiptNumber
      AccountId
      TransferType
      TaskId
      TransferTypeDescription
      StartingOn
      Frequency
      FurtherNotice
      EndingOn
      FromAccountId
      FromAccountDescription
      ToAccountId
      ToAccountDescription
      Billercode
      BillerName
      CustomerReferenceNumber
      Amount
      RegularPayment
      NextScheduledDate
      DepositDescription
      WithdrawalDescription
      NumberOfTimes
      SpecifiedDate
    }
  }
}
    `;
export const RequestPayAnyoneTransferMutationComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: RequestPayAnyoneTransferMutationDocument, ...props }));
export function withRequestPayAnyoneTransferMutation(operationOptions) {
    return ApolloReactHoc.withMutation(RequestPayAnyoneTransferMutationDocument, {
        alias: 'requestPayAnyoneTransferMutation',
        ...operationOptions
    });
}
;
/**
 * __useRequestPayAnyoneTransferMutationMutation__
 *
 * To run a mutation, you first call `useRequestPayAnyoneTransferMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPayAnyoneTransferMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPayAnyoneTransferMutationMutation, { data, loading, error }] = useRequestPayAnyoneTransferMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPayAnyoneTransferMutationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RequestPayAnyoneTransferMutationDocument, options);
}
export const CloseOtherSessionsDocument = gql `
    mutation CloseOtherSessions($input: ForceCloseCurrentUserSessionsInput!) {
  closeCurrentUserSessions(input: $input) {
    clientMutationId
    Data {
      Id
      Features
      CurrentServerTime
      LastLoginAttempt
      LastLoginFrom
      LastPasswordChange
      IsFirstLogin
      CurrentSession {
        Id
        IsDeleted
        LastActivity
        SessionStart
        EventDate
        IpAddress
        Successful
        ClientVersion
        UserAgentHeader
        Expires
      }
      LoginAttempts {
        Id
        EventDate
        IpAddress
        Successful
        ClientVersion
        UserAgentHeader
        IsDeleted
        LastActivity
        SessionStart
        Expires
      }
    }
  }
}
    `;
export const CloseOtherSessionsComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: CloseOtherSessionsDocument, ...props }));
export function withCloseOtherSessions(operationOptions) {
    return ApolloReactHoc.withMutation(CloseOtherSessionsDocument, {
        alias: 'closeOtherSessions',
        ...operationOptions
    });
}
;
/**
 * __useCloseOtherSessionsMutation__
 *
 * To run a mutation, you first call `useCloseOtherSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseOtherSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeOtherSessionsMutation, { data, loading, error }] = useCloseOtherSessionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseOtherSessionsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CloseOtherSessionsDocument, options);
}
export const ChangeCurrentUserPasswordDocument = gql `
    mutation changeCurrentUserPassword($input: ChangePasswordInput!) {
  changeCurrentUserPassword(input: $input) {
    Code
    Success
    Message
    UserSession {
      Id
      Features
      CurrentServerTime
      LastLoginAttempt
      LastLoginFrom
      LastPasswordChange
      IsFirstLogin
      HasTempPassword
      UseMultiFactorAuth
      Party {
        Id
        PartyNumber
        FullName
        OrganisationName
        FirstName
        LastName
      }
    }
  }
}
    `;
export const ChangeCurrentUserPasswordComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: ChangeCurrentUserPasswordDocument, ...props }));
export function withChangeCurrentUserPassword(operationOptions) {
    return ApolloReactHoc.withMutation(ChangeCurrentUserPasswordDocument, {
        alias: 'changeCurrentUserPassword',
        ...operationOptions
    });
}
;
/**
 * __useChangeCurrentUserPasswordMutation__
 *
 * To run a mutation, you first call `useChangeCurrentUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCurrentUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCurrentUserPasswordMutation, { data, loading, error }] = useChangeCurrentUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeCurrentUserPasswordMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ChangeCurrentUserPasswordDocument, options);
}
export const PasswordValidatorByApplicationDocument = gql `
    query passwordValidatorByApplication {
  passwordValidatorByApplication {
    MinimumPasswordLength
    RequireLowerCaseCharacters
    MinimumLowerCaseCharacterCount
    RequireUpperCaseCharacters
    MinimumUpperCaseCharacterCount
    RequireNumberCharacters
    MinimumNumberCharacterCount
    RequireBaseSymbols
    MinimumBaseSymbolCharacterCount
    RequireExtendedSymbols
    MinimumExtendedSymbolCharacterCount
    ProhibitSequentialAlphabetCharacters
    ProhibitSequentialNumberCharacters
    ProhibitRepeatingAlphabetCharacters
    ProhibitRepeatingNumberCharacters
    ProhibitRepeatingSymbolCharacters
    MinimumPasswordHistory
  }
}
    `;
export const PasswordValidatorByApplicationComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: PasswordValidatorByApplicationDocument, ...props }));
export function withPasswordValidatorByApplication(operationOptions) {
    return ApolloReactHoc.withQuery(PasswordValidatorByApplicationDocument, {
        alias: 'passwordValidatorByApplication',
        ...operationOptions
    });
}
;
/**
 * __usePasswordValidatorByApplicationQuery__
 *
 * To run a query within a React component, call `usePasswordValidatorByApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePasswordValidatorByApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePasswordValidatorByApplicationQuery({
 *   variables: {
 *   },
 * });
 */
export function usePasswordValidatorByApplicationQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(PasswordValidatorByApplicationDocument, options);
}
export function usePasswordValidatorByApplicationLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(PasswordValidatorByApplicationDocument, options);
}
export function usePasswordValidatorByApplicationSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(PasswordValidatorByApplicationDocument, options);
}
export const RequestPasswordResetDocument = gql `
    mutation requestPasswordReset($input: ResetPasswordInput!) {
  requestPasswordReset(input: $input) {
    Code
    Success
    Message
  }
}
    `;
export const RequestPasswordResetComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: RequestPasswordResetDocument, ...props }));
export function withRequestPasswordReset(operationOptions) {
    return ApolloReactHoc.withMutation(RequestPasswordResetDocument, {
        alias: 'requestPasswordReset',
        ...operationOptions
    });
}
;
/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RequestPasswordResetDocument, options);
}
export const ArchiveSecureMessageDocument = gql `
    mutation archiveSecureMessage($input: ArchiveSecureMessageInput!) {
  archiveSecureMessage(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export const ArchiveSecureMessageComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: ArchiveSecureMessageDocument, ...props }));
export function withArchiveSecureMessage(operationOptions) {
    return ApolloReactHoc.withMutation(ArchiveSecureMessageDocument, {
        alias: 'archiveSecureMessage',
        ...operationOptions
    });
}
;
/**
 * __useArchiveSecureMessageMutation__
 *
 * To run a mutation, you first call `useArchiveSecureMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSecureMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSecureMessageMutation, { data, loading, error }] = useArchiveSecureMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveSecureMessageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ArchiveSecureMessageDocument, options);
}
export const ReadSecureMessageDocument = gql `
    mutation readSecureMessage($input: ReadSecureMessageInput!) {
  readSecureMessage(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export const ReadSecureMessageComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: ReadSecureMessageDocument, ...props }));
export function withReadSecureMessage(operationOptions) {
    return ApolloReactHoc.withMutation(ReadSecureMessageDocument, {
        alias: 'readSecureMessage',
        ...operationOptions
    });
}
;
/**
 * __useReadSecureMessageMutation__
 *
 * To run a mutation, you first call `useReadSecureMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadSecureMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readSecureMessageMutation, { data, loading, error }] = useReadSecureMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReadSecureMessageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ReadSecureMessageDocument, options);
}
export const CreateNewSecureMessageDocument = gql `
    mutation createNewSecureMessage($input: RequestNewSecureMessageInput!) {
  requestNewSecureMessage(input: $input) {
    Code
    clientMutationId
    Message
    Success
    GraphSecureMessage {
      DateArchived
      DateRead
      DateReplied
      Id
      IsArchived
      IsRead
      IsReplied
      ProfileId
      ShortDescription
      Subject
      ToDoItem {
        AccountNumber
        Id
        Messages {
          CreatedBy
          CreatedOn
          Id
          Text
          Party
          CreatedByFirstName
          CreatedByLastName
          Attachments {
            Id
            IsDeleted
            CreatedOn
            DocumentType
            PrivacyLevel
            Note
            FileName
            Name
          }
        }
        State
        Text
        WithId
        Type {
          Id
          Description
          SecureMessageType {
            Id
            IsAccount
            IsSystem
            Description
            DisplayOrder
            Name
          }
        }
      }
      Attachments {
        Id
        IsDeleted
        CreatedOn
        DocumentType
        PrivacyLevel
        Note
        FileName
        Name
      }
      Type
    }
  }
}
    `;
export const CreateNewSecureMessageComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: CreateNewSecureMessageDocument, ...props }));
export function withCreateNewSecureMessage(operationOptions) {
    return ApolloReactHoc.withMutation(CreateNewSecureMessageDocument, {
        alias: 'createNewSecureMessage',
        ...operationOptions
    });
}
;
/**
 * __useCreateNewSecureMessageMutation__
 *
 * To run a mutation, you first call `useCreateNewSecureMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewSecureMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewSecureMessageMutation, { data, loading, error }] = useCreateNewSecureMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewSecureMessageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateNewSecureMessageDocument, options);
}
export const CreateNewSecureReplyDocument = gql `
    mutation createNewSecureReply($input: RequestNewSecureReplyInput!) {
  requestNewSecureReply(input: $input) {
    Code
    clientMutationId
    Message
    Success
    GraphSecureMessage {
      DateArchived
      DateRead
      DateReplied
      Id
      IsArchived
      IsRead
      IsReplied
      ProfileId
      ShortDescription
      Subject
      ToDoItem {
        AccountNumber
        Id
        Messages {
          CreatedBy
          CreatedOn
          Id
          Text
          Party
          CreatedByFirstName
          CreatedByLastName
          Attachments {
            Id
            IsDeleted
            CreatedOn
            DocumentType
            PrivacyLevel
            Note
            FileName
            Name
          }
        }
        State
        Text
        WithId
        Type {
          Id
          Description
          SecureMessageType {
            Id
            IsAccount
            IsSystem
            Description
            DisplayOrder
            Name
          }
        }
      }
      Attachments {
        Id
        IsDeleted
        CreatedOn
        DocumentType
        PrivacyLevel
        Note
        FileName
        Name
      }
    }
  }
}
    `;
export const CreateNewSecureReplyComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: CreateNewSecureReplyDocument, ...props }));
export function withCreateNewSecureReply(operationOptions) {
    return ApolloReactHoc.withMutation(CreateNewSecureReplyDocument, {
        alias: 'createNewSecureReply',
        ...operationOptions
    });
}
;
/**
 * __useCreateNewSecureReplyMutation__
 *
 * To run a mutation, you first call `useCreateNewSecureReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewSecureReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewSecureReplyMutation, { data, loading, error }] = useCreateNewSecureReplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewSecureReplyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateNewSecureReplyDocument, options);
}
export const SecureMessagesByPartyDocument = gql `
    query secureMessagesByParty {
  secureMessagesByParty {
    SecureMessages {
      Id
      ProfileId
      ToDoItem {
        Id
        WithId
        State
        Text
        Messages {
          Id
          CreatedOn
          CreatedBy
          Text
          Party
          CreatedByFirstName
          CreatedByLastName
          Attachments {
            Id
            IsDeleted
            CreatedOn
            DocumentType
            PrivacyLevel
            Note
            FileName
            Name
          }
        }
        AccountNumber
        Type {
          Id
          Description
          SecureMessageType {
            Id
            IsAccount
            IsSystem
            Description
            DisplayOrder
            Name
          }
        }
      }
      IsArchived
      DateArchived
      IsRead
      DateRead
      IsReplied
      DateReplied
      Subject
      Type
      ShortDescription
      Attachments {
        Id
        IsDeleted
        CreatedOn
        DocumentType
        PrivacyLevel
        Note
        FileName
        Name
      }
    }
    UnreadMessageCount
  }
}
    `;
export const SecureMessagesByPartyComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: SecureMessagesByPartyDocument, ...props }));
export function withSecureMessagesByParty(operationOptions) {
    return ApolloReactHoc.withQuery(SecureMessagesByPartyDocument, {
        alias: 'secureMessagesByParty',
        ...operationOptions
    });
}
;
/**
 * __useSecureMessagesByPartyQuery__
 *
 * To run a query within a React component, call `useSecureMessagesByPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecureMessagesByPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecureMessagesByPartyQuery({
 *   variables: {
 *   },
 * });
 */
export function useSecureMessagesByPartyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SecureMessagesByPartyDocument, options);
}
export function useSecureMessagesByPartyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SecureMessagesByPartyDocument, options);
}
export function useSecureMessagesByPartySuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(SecureMessagesByPartyDocument, options);
}
export const UnreadMessagesCountByPartyDocument = gql `
    query unreadMessagesCountByParty {
  secureMessagesByParty {
    UnreadMessageCount
  }
}
    `;
export const UnreadMessagesCountByPartyComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: UnreadMessagesCountByPartyDocument, ...props }));
export function withUnreadMessagesCountByParty(operationOptions) {
    return ApolloReactHoc.withQuery(UnreadMessagesCountByPartyDocument, {
        alias: 'unreadMessagesCountByParty',
        ...operationOptions
    });
}
;
/**
 * __useUnreadMessagesCountByPartyQuery__
 *
 * To run a query within a React component, call `useUnreadMessagesCountByPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadMessagesCountByPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadMessagesCountByPartyQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadMessagesCountByPartyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(UnreadMessagesCountByPartyDocument, options);
}
export function useUnreadMessagesCountByPartyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(UnreadMessagesCountByPartyDocument, options);
}
export function useUnreadMessagesCountByPartySuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(UnreadMessagesCountByPartyDocument, options);
}
export const AcceptTermsDocument = gql `
    mutation AcceptTerms {
  acceptTerms {
    UserSession {
      Id
      LastTermsAcceptance
    }
  }
}
    `;
export const AcceptTermsComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: AcceptTermsDocument, ...props }));
export function withAcceptTerms(operationOptions) {
    return ApolloReactHoc.withMutation(AcceptTermsDocument, {
        alias: 'acceptTerms',
        ...operationOptions
    });
}
;
/**
 * __useAcceptTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutation, { data, loading, error }] = useAcceptTermsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptTermsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AcceptTermsDocument, options);
}
export const AllowElectronicCommunicationsOptOutDocument = gql `
    query allowElectronicCommunicationsOptOut {
  userSession {
    Id
    AllowElectronicCommunicationsOptOut
  }
}
    `;
export const AllowElectronicCommunicationsOptOutComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: AllowElectronicCommunicationsOptOutDocument, ...props }));
export function withAllowElectronicCommunicationsOptOut(operationOptions) {
    return ApolloReactHoc.withQuery(AllowElectronicCommunicationsOptOutDocument, {
        alias: 'allowElectronicCommunicationsOptOut',
        ...operationOptions
    });
}
;
/**
 * __useAllowElectronicCommunicationsOptOutQuery__
 *
 * To run a query within a React component, call `useAllowElectronicCommunicationsOptOutQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowElectronicCommunicationsOptOutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowElectronicCommunicationsOptOutQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllowElectronicCommunicationsOptOutQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(AllowElectronicCommunicationsOptOutDocument, options);
}
export function useAllowElectronicCommunicationsOptOutLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(AllowElectronicCommunicationsOptOutDocument, options);
}
export function useAllowElectronicCommunicationsOptOutSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(AllowElectronicCommunicationsOptOutDocument, options);
}
export const AllowRegularPaymentChangesDocument = gql `
    query allowRegularPaymentChanges {
  userSession {
    Id
    AllowRegularPaymentChanges
  }
}
    `;
export const AllowRegularPaymentChangesComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: AllowRegularPaymentChangesDocument, ...props }));
export function withAllowRegularPaymentChanges(operationOptions) {
    return ApolloReactHoc.withQuery(AllowRegularPaymentChangesDocument, {
        alias: 'allowRegularPaymentChanges',
        ...operationOptions
    });
}
;
/**
 * __useAllowRegularPaymentChangesQuery__
 *
 * To run a query within a React component, call `useAllowRegularPaymentChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowRegularPaymentChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowRegularPaymentChangesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllowRegularPaymentChangesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(AllowRegularPaymentChangesDocument, options);
}
export function useAllowRegularPaymentChangesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(AllowRegularPaymentChangesDocument, options);
}
export function useAllowRegularPaymentChangesSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(AllowRegularPaymentChangesDocument, options);
}
export const BankingUserLoginDocument = gql `
    mutation BankingUserLogin($input: LoginInput!) {
  login(input: $input) {
    Code
    Message
    Success
    UserSession {
      Id
      FinanceSummary {
        Id
      }
      Features
      CurrentServerTime
      LastLoginAttempt
      LastLoginFrom
      LastPasswordChange
      IsFirstLogin
      Party {
        Id
        PartyNumber
        FirstName
        LastName
        FullName
      }
      IsSharia
    }
  }
}
    `;
export const BankingUserLoginComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: BankingUserLoginDocument, ...props }));
export function withBankingUserLogin(operationOptions) {
    return ApolloReactHoc.withMutation(BankingUserLoginDocument, {
        alias: 'bankingUserLogin',
        ...operationOptions
    });
}
;
/**
 * __useBankingUserLoginMutation__
 *
 * To run a mutation, you first call `useBankingUserLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankingUserLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankingUserLoginMutation, { data, loading, error }] = useBankingUserLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBankingUserLoginMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(BankingUserLoginDocument, options);
}
export const BankingUserLoginV2Document = gql `
    mutation BankingUserLoginV2($input: LoginV2Input!) {
  loginV2(input: $input) {
    AccessToken
    TrustedDeviceToken
    CanUseTrustedDevice
    AuthMessage
    AuthError
    AuthSucceeded
    IsUsingGoogleAuth
    UserSession {
      Id
      FinanceSummary {
        Id
      }
      Features
      CurrentServerTime
      LastLoginAttempt
      LastLoginFrom
      LastPasswordChange
      IsFirstLogin
      Party {
        Id
        PartyNumber
        FirstName
        LastName
        FullName
      }
      IsSharia
    }
  }
}
    `;
export const BankingUserLoginV2Component = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: BankingUserLoginV2Document, ...props }));
export function withBankingUserLoginV2(operationOptions) {
    return ApolloReactHoc.withMutation(BankingUserLoginV2Document, {
        alias: 'bankingUserLoginV2',
        ...operationOptions
    });
}
;
/**
 * __useBankingUserLoginV2Mutation__
 *
 * To run a mutation, you first call `useBankingUserLoginV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankingUserLoginV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankingUserLoginV2Mutation, { data, loading, error }] = useBankingUserLoginV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBankingUserLoginV2Mutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(BankingUserLoginV2Document, options);
}
export const BankingUserLogoutDocument = gql `
    mutation BankingUserLogout {
  logout {
    __typename
  }
}
    `;
export const BankingUserLogoutComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: BankingUserLogoutDocument, ...props }));
export function withBankingUserLogout(operationOptions) {
    return ApolloReactHoc.withMutation(BankingUserLogoutDocument, {
        alias: 'bankingUserLogout',
        ...operationOptions
    });
}
;
/**
 * __useBankingUserLogoutMutation__
 *
 * To run a mutation, you first call `useBankingUserLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBankingUserLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bankingUserLogoutMutation, { data, loading, error }] = useBankingUserLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useBankingUserLogoutMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(BankingUserLogoutDocument, options);
}
export const DisableProfileAuthenticatorDocument = gql `
    mutation disableProfileAuthenticator($input: DisableProfileAuthenticatorInput!) {
  disableProfileAuthenticator(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export const DisableProfileAuthenticatorComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: DisableProfileAuthenticatorDocument, ...props }));
export function withDisableProfileAuthenticator(operationOptions) {
    return ApolloReactHoc.withMutation(DisableProfileAuthenticatorDocument, {
        alias: 'disableProfileAuthenticator',
        ...operationOptions
    });
}
;
/**
 * __useDisableProfileAuthenticatorMutation__
 *
 * To run a mutation, you first call `useDisableProfileAuthenticatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableProfileAuthenticatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableProfileAuthenticatorMutation, { data, loading, error }] = useDisableProfileAuthenticatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableProfileAuthenticatorMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DisableProfileAuthenticatorDocument, options);
}
export const EnableProfileAuthenticatorDocument = gql `
    mutation enableProfileAuthenticator($input: EnableProfileAuthenticatorInput!) {
  enableProfileAuthenticator(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export const EnableProfileAuthenticatorComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: EnableProfileAuthenticatorDocument, ...props }));
export function withEnableProfileAuthenticator(operationOptions) {
    return ApolloReactHoc.withMutation(EnableProfileAuthenticatorDocument, {
        alias: 'enableProfileAuthenticator',
        ...operationOptions
    });
}
;
/**
 * __useEnableProfileAuthenticatorMutation__
 *
 * To run a mutation, you first call `useEnableProfileAuthenticatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableProfileAuthenticatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableProfileAuthenticatorMutation, { data, loading, error }] = useEnableProfileAuthenticatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableProfileAuthenticatorMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(EnableProfileAuthenticatorDocument, options);
}
export const GenerateAuthSecretDocument = gql `
    mutation generateAuthSecret($input: GenerateAuthSecretInput!) {
  generateAuthSecret(input: $input) {
    clientMutationId
    Code
    Message
    Success
    AuthSecret
  }
}
    `;
export const GenerateAuthSecretComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: GenerateAuthSecretDocument, ...props }));
export function withGenerateAuthSecret(operationOptions) {
    return ApolloReactHoc.withMutation(GenerateAuthSecretDocument, {
        alias: 'generateAuthSecret',
        ...operationOptions
    });
}
;
/**
 * __useGenerateAuthSecretMutation__
 *
 * To run a mutation, you first call `useGenerateAuthSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAuthSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAuthSecretMutation, { data, loading, error }] = useGenerateAuthSecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAuthSecretMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateAuthSecretDocument, options);
}
export const IsUserAuthenticatedDocument = gql `
    query isUserAuthenticated {
  userSession {
    Id
    Features
    CurrentServerTime
    LastLoginAttempt
    LastLoginFrom
    LastPasswordChange
    LastTermsAcceptance
    IsFirstLogin
    HasTempPassword
    UseMultiFactorAuth
    IsUsingGoogleAuth
    PartyPaymentLimitsEnabled
    UnreadMessageCount
    FcsEnabled
    Party {
      Id
      PartyNumber
      FullName
      OrganisationName
      FirstName
      LastName
      SearchName
      PreferredCorrespondanceType
    }
    CurrentSession {
      Id
      IsDeleted
      LastActivity
      SessionStart
      Expires
      EventDate
      IpAddress
      Successful
      ClientVersion
      UserAgentHeader
    }
    LoginAttempts {
      Id
      IsDeleted
      LastActivity
      SessionStart
      Expires
      EventDate
      IpAddress
      Successful
      ClientVersion
      UserAgentHeader
    }
    AllowViewBatchPayments
    AllowCreateBatchPayments
  }
}
    `;
export const IsUserAuthenticatedComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: IsUserAuthenticatedDocument, ...props }));
export function withIsUserAuthenticated(operationOptions) {
    return ApolloReactHoc.withQuery(IsUserAuthenticatedDocument, {
        alias: 'isUserAuthenticated',
        ...operationOptions
    });
}
;
/**
 * __useIsUserAuthenticatedQuery__
 *
 * To run a query within a React component, call `useIsUserAuthenticatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsUserAuthenticatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsUserAuthenticatedQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsUserAuthenticatedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(IsUserAuthenticatedDocument, options);
}
export function useIsUserAuthenticatedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(IsUserAuthenticatedDocument, options);
}
export function useIsUserAuthenticatedSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(IsUserAuthenticatedDocument, options);
}
export const PartyChangeElectronicCommsStatusDocument = gql `
    mutation partyChangeElectronicCommsStatus($input: ChangeElectronicCommsStatusInput!) {
  changeElectronicCommsStatus(input: $input) {
    clientMutationId
    Code
    Success
    Message
    SMSNotificationStatus
    EmailNotificationStatus
    StatementNotificationStatus
  }
}
    `;
export const PartyChangeElectronicCommsStatusComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: PartyChangeElectronicCommsStatusDocument, ...props }));
export function withPartyChangeElectronicCommsStatus(operationOptions) {
    return ApolloReactHoc.withMutation(PartyChangeElectronicCommsStatusDocument, {
        alias: 'partyChangeElectronicCommsStatus',
        ...operationOptions
    });
}
;
/**
 * __usePartyChangeElectronicCommsStatusMutation__
 *
 * To run a mutation, you first call `usePartyChangeElectronicCommsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartyChangeElectronicCommsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partyChangeElectronicCommsStatusMutation, { data, loading, error }] = usePartyChangeElectronicCommsStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartyChangeElectronicCommsStatusMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(PartyChangeElectronicCommsStatusDocument, options);
}
export const PartyChangeMarketingCommsStatusDocument = gql `
    mutation partyChangeMarketingCommsStatus($input: ChangeMarketingCommsStatusInput!) {
  changeMarketingCommsStatus(input: $input) {
    clientMutationId
    Code
    Success
    Message
    MarketingStatus
  }
}
    `;
export const PartyChangeMarketingCommsStatusComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: PartyChangeMarketingCommsStatusDocument, ...props }));
export function withPartyChangeMarketingCommsStatus(operationOptions) {
    return ApolloReactHoc.withMutation(PartyChangeMarketingCommsStatusDocument, {
        alias: 'partyChangeMarketingCommsStatus',
        ...operationOptions
    });
}
;
/**
 * __usePartyChangeMarketingCommsStatusMutation__
 *
 * To run a mutation, you first call `usePartyChangeMarketingCommsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartyChangeMarketingCommsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partyChangeMarketingCommsStatusMutation, { data, loading, error }] = usePartyChangeMarketingCommsStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartyChangeMarketingCommsStatusMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(PartyChangeMarketingCommsStatusDocument, options);
}
export const PartyChangePersonalDetailsDocument = gql `
    mutation partyChangePersonalDetails($input: PartyPersonalDetailsInput!) {
  partyPersonalDetails(input: $input) {
    clientMutationId
    Code
    Success
    Message
    PreferredCorrespondenceMethod
  }
}
    `;
export const PartyChangePersonalDetailsComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: PartyChangePersonalDetailsDocument, ...props }));
export function withPartyChangePersonalDetails(operationOptions) {
    return ApolloReactHoc.withMutation(PartyChangePersonalDetailsDocument, {
        alias: 'partyChangePersonalDetails',
        ...operationOptions
    });
}
;
/**
 * __usePartyChangePersonalDetailsMutation__
 *
 * To run a mutation, you first call `usePartyChangePersonalDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartyChangePersonalDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partyChangePersonalDetailsMutation, { data, loading, error }] = usePartyChangePersonalDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartyChangePersonalDetailsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(PartyChangePersonalDetailsDocument, options);
}
export const PartyElectronicCommsStatusDocument = gql `
    query partyElectronicCommsStatus {
  electronicComms {
    SMSNotificationStatus
    EmailNotificationStatus
    StatementNotificationStatus
  }
}
    `;
export const PartyElectronicCommsStatusComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: PartyElectronicCommsStatusDocument, ...props }));
export function withPartyElectronicCommsStatus(operationOptions) {
    return ApolloReactHoc.withQuery(PartyElectronicCommsStatusDocument, {
        alias: 'partyElectronicCommsStatus',
        ...operationOptions
    });
}
;
/**
 * __usePartyElectronicCommsStatusQuery__
 *
 * To run a query within a React component, call `usePartyElectronicCommsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyElectronicCommsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyElectronicCommsStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartyElectronicCommsStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(PartyElectronicCommsStatusDocument, options);
}
export function usePartyElectronicCommsStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(PartyElectronicCommsStatusDocument, options);
}
export function usePartyElectronicCommsStatusSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(PartyElectronicCommsStatusDocument, options);
}
export const PartyProfileDetailsDocument = gql `
    query partyProfileDetails {
  userSession {
    Id
    IsDeleted
    LastLoginAttempt
    LastLoginFrom
    LastPasswordChange
    PartyPaymentLimitsEnabled
    Party {
      AcceptsAdvertising
      Addresses {
        Address {
          AddressDetailType
          AddressLine1
          AddressLine2
          AddressLine3
          AddressLine4
          Building
          Country {
            Name
          }
          FloorName
          FloorNumber
          HasBeenVerified
          Id
          IsValid
          LotNumber
          PostalBoxDetails
          PostalCode
          PropertyName
          Region {
            Abbreviation
            Name
          }
          StreetName
          StreetNumberFrom
          StreetNumberTo
          StreetType
          SuburbTown
          UnitNumber
        }
        Id
        IsDefaultMailingAddress
        IsDefaultResidentialAddress
        IsDeleted
        IsPrevious
      }
      Contacts {
        Details
        Id
        IsDeleted
        IsPreferredEmail
        IsPreferredPhone
        IsPreferredSms
        Type {
          Description
          Id
          IsPhone
          ReceiveMessages
        }
      }
      EntityType
      FirstName
      Id
      LastName
      OrganisationName
      PartyNumber
      PreferredCorrespondanceType
    }
    UseMultiFactorAuth
  }
}
    `;
export const PartyProfileDetailsComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: PartyProfileDetailsDocument, ...props }));
export function withPartyProfileDetails(operationOptions) {
    return ApolloReactHoc.withQuery(PartyProfileDetailsDocument, {
        alias: 'partyProfileDetails',
        ...operationOptions
    });
}
;
/**
 * __usePartyProfileDetailsQuery__
 *
 * To run a query within a React component, call `usePartyProfileDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyProfileDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyProfileDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartyProfileDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(PartyProfileDetailsDocument, options);
}
export function usePartyProfileDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(PartyProfileDetailsDocument, options);
}
export function usePartyProfileDetailsSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(PartyProfileDetailsDocument, options);
}
export const IndueCardActivateCardDocument = gql `
    mutation IndueCardActivateCard($input: IndueCardActivateCardInput!) {
  indueActivateCard(input: $input) {
    Result
    Success
    ActivateCardResult
    ChangePinResult
    Card {
      Id
      Status
    }
  }
}
    `;
export const IndueCardActivateCardComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: IndueCardActivateCardDocument, ...props }));
export function withIndueCardActivateCard(operationOptions) {
    return ApolloReactHoc.withMutation(IndueCardActivateCardDocument, {
        alias: 'indueCardActivateCard',
        ...operationOptions
    });
}
;
/**
 * __useIndueCardActivateCardMutation__
 *
 * To run a mutation, you first call `useIndueCardActivateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndueCardActivateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indueCardActivateCardMutation, { data, loading, error }] = useIndueCardActivateCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardActivateCardMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(IndueCardActivateCardDocument, options);
}
export const IndueCardChangePinDocument = gql `
    mutation IndueCardChangePin($input: IndueCardChangePinInput!) {
  changePin(input: $input) {
    Result
    Card {
      CardNumber
      ExpiryDate
      Id
      Status
    }
  }
}
    `;
export const IndueCardChangePinComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: IndueCardChangePinDocument, ...props }));
export function withIndueCardChangePin(operationOptions) {
    return ApolloReactHoc.withMutation(IndueCardChangePinDocument, {
        alias: 'indueCardChangePin',
        ...operationOptions
    });
}
;
/**
 * __useIndueCardChangePinMutation__
 *
 * To run a mutation, you first call `useIndueCardChangePinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndueCardChangePinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indueCardChangePinMutation, { data, loading, error }] = useIndueCardChangePinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardChangePinMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(IndueCardChangePinDocument, options);
}
export const IndueCardChangeStatusDocument = gql `
    mutation IndueCardChangeStatus($input: IndueCardChangeStatusInput!) {
  changeStatus(input: $input) {
    Result
    Card {
      CardNumber
      ExpiryDate
      Id
      Status
    }
  }
}
    `;
export const IndueCardChangeStatusComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: IndueCardChangeStatusDocument, ...props }));
export function withIndueCardChangeStatus(operationOptions) {
    return ApolloReactHoc.withMutation(IndueCardChangeStatusDocument, {
        alias: 'indueCardChangeStatus',
        ...operationOptions
    });
}
;
/**
 * __useIndueCardChangeStatusMutation__
 *
 * To run a mutation, you first call `useIndueCardChangeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndueCardChangeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indueCardChangeStatusMutation, { data, loading, error }] = useIndueCardChangeStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardChangeStatusMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(IndueCardChangeStatusDocument, options);
}
export const IndueCardCreateCardDocument = gql `
    mutation IndueCardCreateCard($input: IndueCardCreateCardInput!) {
  createCard(input: $input) {
    Success
    Code
    Message
    Card {
      Id
      Status
    }
  }
}
    `;
export const IndueCardCreateCardComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: IndueCardCreateCardDocument, ...props }));
export function withIndueCardCreateCard(operationOptions) {
    return ApolloReactHoc.withMutation(IndueCardCreateCardDocument, {
        alias: 'indueCardCreateCard',
        ...operationOptions
    });
}
;
/**
 * __useIndueCardCreateCardMutation__
 *
 * To run a mutation, you first call `useIndueCardCreateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndueCardCreateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indueCardCreateCardMutation, { data, loading, error }] = useIndueCardCreateCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardCreateCardMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(IndueCardCreateCardDocument, options);
}
export const IndueCardDetailsDocument = gql `
    query indueCardDetails($input: IndueCardDetailsInput!) {
  indueCardDetails(input: $input) {
    CardNumber
    ExpiryDate
    Id
    Status
    CanActivate
    CanHold
    CanUnHold
    CanReportLostStolen
    CanClose
  }
}
    `;
export const IndueCardDetailsComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: IndueCardDetailsDocument, ...props }));
export function withIndueCardDetails(operationOptions) {
    return ApolloReactHoc.withQuery(IndueCardDetailsDocument, {
        alias: 'indueCardDetails',
        ...operationOptions
    });
}
;
/**
 * __useIndueCardDetailsQuery__
 *
 * To run a query within a React component, call `useIndueCardDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndueCardDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndueCardDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(IndueCardDetailsDocument, options);
}
export function useIndueCardDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(IndueCardDetailsDocument, options);
}
export function useIndueCardDetailsSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(IndueCardDetailsDocument, options);
}
export const IndueCardsandAssociationsByAccountDocument = gql `
    query indueCardsandAssociationsByAccount($accountId: Uuid!, $accountIdString: String!) {
  indueCardsByAccount(input: {AccountId: $accountId}) {
    CardNumber
    ExpiryDate
    Id
    Status
    CanActivate
    CanHold
    CanUnHold
    CanReportLostStolen
    CanClose
  }
  partyAssociationByAccount(input: {Id: $accountIdString}) {
    IsPrimaryBorrower
    IsSecondaryBorrower
    IsNonBorrower
    PrimaryBorrowerHasCard
  }
  accountByIdOrNumber(idOrNumber: $accountIdString) {
    Id
    CurrentUserAccountAuthority {
      Id
      BPay
      Operate
      InterAccount
      DirectDebit
      PayAnyone
      Redraw
      View
    }
  }
}
    `;
export const IndueCardsandAssociationsByAccountComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: IndueCardsandAssociationsByAccountDocument, ...props }));
export function withIndueCardsandAssociationsByAccount(operationOptions) {
    return ApolloReactHoc.withQuery(IndueCardsandAssociationsByAccountDocument, {
        alias: 'indueCardsandAssociationsByAccount',
        ...operationOptions
    });
}
;
/**
 * __useIndueCardsandAssociationsByAccountQuery__
 *
 * To run a query within a React component, call `useIndueCardsandAssociationsByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndueCardsandAssociationsByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndueCardsandAssociationsByAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      accountIdString: // value for 'accountIdString'
 *   },
 * });
 */
export function useIndueCardsandAssociationsByAccountQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(IndueCardsandAssociationsByAccountDocument, options);
}
export function useIndueCardsandAssociationsByAccountLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(IndueCardsandAssociationsByAccountDocument, options);
}
export function useIndueCardsandAssociationsByAccountSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(IndueCardsandAssociationsByAccountDocument, options);
}
export const IndueCardsByAccountDocument = gql `
    query indueCardsByAccount($input: IndueCardsByAccountInput!) {
  indueCardsByAccount(input: $input) {
    CardNumber
    ExpiryDate
    Id
    Status
    CanActivate
    CanHold
    CanUnHold
    CanReportLostStolen
    CanClose
  }
}
    `;
export const IndueCardsByAccountComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: IndueCardsByAccountDocument, ...props }));
export function withIndueCardsByAccount(operationOptions) {
    return ApolloReactHoc.withQuery(IndueCardsByAccountDocument, {
        alias: 'indueCardsByAccount',
        ...operationOptions
    });
}
;
/**
 * __useIndueCardsByAccountQuery__
 *
 * To run a query within a React component, call `useIndueCardsByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndueCardsByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndueCardsByAccountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIndueCardsByAccountQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(IndueCardsByAccountDocument, options);
}
export function useIndueCardsByAccountLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(IndueCardsByAccountDocument, options);
}
export function useIndueCardsByAccountSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(IndueCardsByAccountDocument, options);
}
export const PartyAssociationByAccountDocument = gql `
    query partyAssociationByAccount($input: PartyAssociationByAccountInput!) {
  partyAssociationByAccount(input: $input) {
    IsPrimaryBorrower
    IsSecondaryBorrower
    IsNonBorrower
    PrimaryBorrowerHasCard
  }
}
    `;
export const PartyAssociationByAccountComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: PartyAssociationByAccountDocument, ...props }));
export function withPartyAssociationByAccount(operationOptions) {
    return ApolloReactHoc.withQuery(PartyAssociationByAccountDocument, {
        alias: 'partyAssociationByAccount',
        ...operationOptions
    });
}
;
/**
 * __usePartyAssociationByAccountQuery__
 *
 * To run a query within a React component, call `usePartyAssociationByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyAssociationByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyAssociationByAccountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePartyAssociationByAccountQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(PartyAssociationByAccountDocument, options);
}
export function usePartyAssociationByAccountLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(PartyAssociationByAccountDocument, options);
}
export function usePartyAssociationByAccountSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(PartyAssociationByAccountDocument, options);
}
export const RequestNewMultiFactorSecurityTokenDocument = gql `
    mutation requestNewMultiFactorSecurityToken($input: RequestMultiFactorAuthorisationInput!) {
  requestMultiFactorAuthorisation(input: $input) {
    clientMutationId
    Code
    Message
    Success
  }
}
    `;
export const RequestNewMultiFactorSecurityTokenComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: RequestNewMultiFactorSecurityTokenDocument, ...props }));
export function withRequestNewMultiFactorSecurityToken(operationOptions) {
    return ApolloReactHoc.withMutation(RequestNewMultiFactorSecurityTokenDocument, {
        alias: 'requestNewMultiFactorSecurityToken',
        ...operationOptions
    });
}
;
/**
 * __useRequestNewMultiFactorSecurityTokenMutation__
 *
 * To run a mutation, you first call `useRequestNewMultiFactorSecurityTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestNewMultiFactorSecurityTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestNewMultiFactorSecurityTokenMutation, { data, loading, error }] = useRequestNewMultiFactorSecurityTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestNewMultiFactorSecurityTokenMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RequestNewMultiFactorSecurityTokenDocument, options);
}
export const DisbursementRequestDocument = gql `
    mutation DisbursementRequest($input: DisbursementRequestInput!) {
  disbursementRequest(input: $input) {
    clientMutationId
    Code
    Success
    Message
    Data {
      Id
      PayeeName
      BankIdentifierText
      AccountNumber
      PaymentDescription
      RequestedAmount
      PaymentDate
      Note
      Documents {
        Id
        FileName
        Name
        CreatedOn
        DocumentType
        IsDeleted
        PrivacyLevel
      }
    }
  }
}
    `;
export const DisbursementRequestComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: DisbursementRequestDocument, ...props }));
export function withDisbursementRequest(operationOptions) {
    return ApolloReactHoc.withMutation(DisbursementRequestDocument, {
        alias: 'disbursementRequest',
        ...operationOptions
    });
}
;
/**
 * __useDisbursementRequestMutation__
 *
 * To run a mutation, you first call `useDisbursementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisbursementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disbursementRequestMutation, { data, loading, error }] = useDisbursementRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisbursementRequestMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DisbursementRequestDocument, options);
}
export const DisbursementsMultipleAttachmentFeatureFlagDocument = gql `
    query DisbursementsMultipleAttachmentFeatureFlag {
  featureFlag {
    EnableDisbursementMultipleAttachments
  }
}
    `;
export const DisbursementsMultipleAttachmentFeatureFlagComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: DisbursementsMultipleAttachmentFeatureFlagDocument, ...props }));
export function withDisbursementsMultipleAttachmentFeatureFlag(operationOptions) {
    return ApolloReactHoc.withQuery(DisbursementsMultipleAttachmentFeatureFlagDocument, {
        alias: 'disbursementsMultipleAttachmentFeatureFlag',
        ...operationOptions
    });
}
;
/**
 * __useDisbursementsMultipleAttachmentFeatureFlagQuery__
 *
 * To run a query within a React component, call `useDisbursementsMultipleAttachmentFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisbursementsMultipleAttachmentFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisbursementsMultipleAttachmentFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useDisbursementsMultipleAttachmentFeatureFlagQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(DisbursementsMultipleAttachmentFeatureFlagDocument, options);
}
export function useDisbursementsMultipleAttachmentFeatureFlagLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(DisbursementsMultipleAttachmentFeatureFlagDocument, options);
}
export function useDisbursementsMultipleAttachmentFeatureFlagSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(DisbursementsMultipleAttachmentFeatureFlagDocument, options);
}
export const DocumentsForCurrentUserDocument = gql `
    query DocumentsForCurrentUser {
  financeSummary {
    Id
    Instruments {
      Id
      Documents {
        Id
        Document {
          Id
          IsDeleted
          CreatedOn
          DocumentType
          PrivacyLevel
          Note
          FileName
          Name
        }
        IsDeleted
      }
      Number
      Accounts {
        Id
        Number
        InstrumentId
        Documents {
          Id
          Document {
            Id
            IsDeleted
            CreatedOn
            DocumentType
            PrivacyLevel
            Note
            FileName
            Name
          }
          IsDeleted
        }
      }
    }
  }
  userSession {
    Id
    Party {
      Id
      Documents {
        Id
        Document {
          Id
          IsDeleted
          CreatedOn
          DocumentType
          PrivacyLevel
          Note
          FileName
          Name
        }
        IsDeleted
      }
    }
  }
}
    `;
export const DocumentsForCurrentUserComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: DocumentsForCurrentUserDocument, ...props }));
export function withDocumentsForCurrentUser(operationOptions) {
    return ApolloReactHoc.withQuery(DocumentsForCurrentUserDocument, {
        alias: 'documentsForCurrentUser',
        ...operationOptions
    });
}
;
/**
 * __useDocumentsForCurrentUserQuery__
 *
 * To run a query within a React component, call `useDocumentsForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsForCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentsForCurrentUserQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(DocumentsForCurrentUserDocument, options);
}
export function useDocumentsForCurrentUserLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(DocumentsForCurrentUserDocument, options);
}
export function useDocumentsForCurrentUserSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(DocumentsForCurrentUserDocument, options);
}
export const FcsAlternateAdiDocument = gql `
    mutation FCSAlternateADI($input: FCSAlternateADIInput!) {
  fCSAlternateADI(input: $input) {
    Success
  }
}
    `;
export const FcsAlternateAdiComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: FcsAlternateAdiDocument, ...props }));
export function withFcsAlternateAdi(operationOptions) {
    return ApolloReactHoc.withMutation(FcsAlternateAdiDocument, {
        alias: 'fcsAlternateAdi',
        ...operationOptions
    });
}
;
/**
 * __useFcsAlternateAdiMutation__
 *
 * To run a mutation, you first call `useFcsAlternateAdiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFcsAlternateAdiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fcsAlternateAdiMutation, { data, loading, error }] = useFcsAlternateAdiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFcsAlternateAdiMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(FcsAlternateAdiDocument, options);
}
export const FinanceSummaryDocument = gql `
    query FinanceSummary {
  financeSummary {
    Id
    TotalPrincipal {
      CurrencyCode
      Amount
    }
    TotalRedraw {
      CurrencyCode
      Amount
    }
    Instruments {
      Id
      Number
      LoanPurpose
      Description
      TotalPrincipal
      TotalRedraw
      Status
      IsUnderHardshipAgreement
      InstrumentType
      Term
      TotalTermMonths
      RemainingTermMonths
      MaturityDate
      PrimaryBorrower
      Accounts {
        Id
        Number
        Description
        DisplayOrder
        InstrumentId
        LegacyNumber
        ProductType
        CurrentBalance
        Redraw
        InterestType
        CardAccount
        RemainingDisbursementAmount
        IsCashAccount
        IsNonMaturing
        DisableDisbursements
      }
    }
  }
}
    `;
export const FinanceSummaryComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: FinanceSummaryDocument, ...props }));
export function withFinanceSummary(operationOptions) {
    return ApolloReactHoc.withQuery(FinanceSummaryDocument, {
        alias: 'financeSummary',
        ...operationOptions
    });
}
;
/**
 * __useFinanceSummaryQuery__
 *
 * To run a query within a React component, call `useFinanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinanceSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinanceSummaryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(FinanceSummaryDocument, options);
}
export function useFinanceSummaryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(FinanceSummaryDocument, options);
}
export function useFinanceSummarySuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FinanceSummaryDocument, options);
}
export const InstrumentByIdOrNumberDocument = gql `
    query instrumentByIdOrNumber($idOrNumber: String!) {
  instrumentByIdOrNumber(idOrNumber: $idOrNumber) {
    Id
    Number
    LoanPurpose
    Description
    TotalPrincipal
    TotalRedraw
    Status
    IsUnderHardshipAgreement
    InstrumentType
    Term
    TotalTermMonths
    RemainingTermMonths
    MaturityDate
    RedrawConsideration
    PrimaryBorrower
    Accounts {
      Id
      Number
      Description
      DisplayOrder
      InstrumentId
      LegacyNumber
      ProductType
      CurrentBalance
      Redraw
      InterestType
      CardAccount
      RedrawFlag
      OffsetAccount
      CardAvailable
      IsCashAccount
      IsNonMaturing
      DisableDisbursements
    }
  }
}
    `;
export const InstrumentByIdOrNumberComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: InstrumentByIdOrNumberDocument, ...props }));
export function withInstrumentByIdOrNumber(operationOptions) {
    return ApolloReactHoc.withQuery(InstrumentByIdOrNumberDocument, {
        alias: 'instrumentByIdOrNumber',
        ...operationOptions
    });
}
;
/**
 * __useInstrumentByIdOrNumberQuery__
 *
 * To run a query within a React component, call `useInstrumentByIdOrNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstrumentByIdOrNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstrumentByIdOrNumberQuery({
 *   variables: {
 *      idOrNumber: // value for 'idOrNumber'
 *   },
 * });
 */
export function useInstrumentByIdOrNumberQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(InstrumentByIdOrNumberDocument, options);
}
export function useInstrumentByIdOrNumberLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(InstrumentByIdOrNumberDocument, options);
}
export function useInstrumentByIdOrNumberSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(InstrumentByIdOrNumberDocument, options);
}
export const IsShariaDocument = gql `
    query IsSharia {
  userSession {
    Id
    IsSharia
  }
}
    `;
export const IsShariaComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: IsShariaDocument, ...props }));
export function withIsSharia(operationOptions) {
    return ApolloReactHoc.withQuery(IsShariaDocument, {
        alias: 'isSharia',
        ...operationOptions
    });
}
;
/**
 * __useIsShariaQuery__
 *
 * To run a query within a React component, call `useIsShariaQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsShariaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsShariaQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsShariaQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(IsShariaDocument, options);
}
export function useIsShariaLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(IsShariaDocument, options);
}
export function useIsShariaSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(IsShariaDocument, options);
}
export const MaxLimitsDocument = gql `
    query maxLimits {
  userSession {
    Id
    RedrawLimitMax
    PayAnyoneLimitMax
    BPayLimitMax
  }
}
    `;
export const MaxLimitsComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: MaxLimitsDocument, ...props }));
export function withMaxLimits(operationOptions) {
    return ApolloReactHoc.withQuery(MaxLimitsDocument, {
        alias: 'maxLimits',
        ...operationOptions
    });
}
;
/**
 * __useMaxLimitsQuery__
 *
 * To run a query within a React component, call `useMaxLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaxLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaxLimitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaxLimitsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(MaxLimitsDocument, options);
}
export function useMaxLimitsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(MaxLimitsDocument, options);
}
export function useMaxLimitsSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(MaxLimitsDocument, options);
}
export const PartyLimitDocument = gql `
    query partyLimit {
  partyLimits {
    DailyRedrawLimit {
      CurrencyCode
      Amount
    }
    DefaultRedrawLimit {
      CurrencyCode
      Amount
    }
    RemainingDailyRedrawLimit {
      CurrencyCode
      Amount
    }
    DailyPayAnyoneLimit {
      CurrencyCode
      Amount
    }
    DefaultPayAnyoneLimit {
      CurrencyCode
      Amount
    }
    RemainingDailyPayAnyoneLimit {
      CurrencyCode
      Amount
    }
    DailyBPayLimit {
      CurrencyCode
      Amount
    }
    DefaultBPayLimit {
      CurrencyCode
      Amount
    }
    RemainingDailyBPayLimit {
      CurrencyCode
      Amount
    }
    LimitEffectiveTo
  }
}
    `;
export const PartyLimitComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: PartyLimitDocument, ...props }));
export function withPartyLimit(operationOptions) {
    return ApolloReactHoc.withQuery(PartyLimitDocument, {
        alias: 'partyLimit',
        ...operationOptions
    });
}
;
/**
 * __usePartyLimitQuery__
 *
 * To run a query within a React component, call `usePartyLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartyLimitQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(PartyLimitDocument, options);
}
export function usePartyLimitLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(PartyLimitDocument, options);
}
export function usePartyLimitSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(PartyLimitDocument, options);
}
export const SecureMessageTypesDocument = gql `
    query secureMessageTypes {
  secureMessageTypes {
    Id
    IsAccount
    IsSystem
    Name
    Description
    DisplayOrder
  }
}
    `;
export const SecureMessageTypesComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: SecureMessageTypesDocument, ...props }));
export function withSecureMessageTypes(operationOptions) {
    return ApolloReactHoc.withQuery(SecureMessageTypesDocument, {
        alias: 'secureMessageTypes',
        ...operationOptions
    });
}
;
/**
 * __useSecureMessageTypesQuery__
 *
 * To run a query within a React component, call `useSecureMessageTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecureMessageTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecureMessageTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSecureMessageTypesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SecureMessageTypesDocument, options);
}
export function useSecureMessageTypesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SecureMessageTypesDocument, options);
}
export function useSecureMessageTypesSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(SecureMessageTypesDocument, options);
}
export const StatementsByPartyIdDocument = gql `
    query statementsByPartyId {
  statementsByPartyId {
    Id
    AccountId
    AccountNumber
    AdHoc
    CreatedOn
    InstrumentId
    Number
    PeriodFrom
    PeriodTo
    Filename
    FileId
  }
}
    `;
export const StatementsByPartyIdComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: StatementsByPartyIdDocument, ...props }));
export function withStatementsByPartyId(operationOptions) {
    return ApolloReactHoc.withQuery(StatementsByPartyIdDocument, {
        alias: 'statementsByPartyId',
        ...operationOptions
    });
}
;
/**
 * __useStatementsByPartyIdQuery__
 *
 * To run a query within a React component, call `useStatementsByPartyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatementsByPartyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatementsByPartyIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatementsByPartyIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(StatementsByPartyIdDocument, options);
}
export function useStatementsByPartyIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(StatementsByPartyIdDocument, options);
}
export function useStatementsByPartyIdSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(StatementsByPartyIdDocument, options);
}
export const ToDoItemTypesDocument = gql `
    query toDoItemTypes($input: ToDoItemTypesInput!) {
  toDoItemTypes(input: $input) {
    Id
    Description
    SecureMessageType {
      Id
      IsAccount
      IsSystem
      Description
      DisplayOrder
      Name
    }
  }
}
    `;
export const ToDoItemTypesComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: ToDoItemTypesDocument, ...props }));
export function withToDoItemTypes(operationOptions) {
    return ApolloReactHoc.withQuery(ToDoItemTypesDocument, {
        alias: 'toDoItemTypes',
        ...operationOptions
    });
}
;
/**
 * __useToDoItemTypesQuery__
 *
 * To run a query within a React component, call `useToDoItemTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useToDoItemTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToDoItemTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToDoItemTypesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(ToDoItemTypesDocument, options);
}
export function useToDoItemTypesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(ToDoItemTypesDocument, options);
}
export function useToDoItemTypesSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(ToDoItemTypesDocument, options);
}
export const ExportAccountTransactionsDocument = gql `
    mutation ExportAccountTransactions($input: ExportAccountTransactionsInput!) {
  exportAccountTransactions(input: $input) {
    ExportString
  }
}
    `;
export const ExportAccountTransactionsComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: ExportAccountTransactionsDocument, ...props }));
export function withExportAccountTransactions(operationOptions) {
    return ApolloReactHoc.withMutation(ExportAccountTransactionsDocument, {
        alias: 'exportAccountTransactions',
        ...operationOptions
    });
}
;
/**
 * __useExportAccountTransactionsMutation__
 *
 * To run a mutation, you first call `useExportAccountTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAccountTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAccountTransactionsMutation, { data, loading, error }] = useExportAccountTransactionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportAccountTransactionsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ExportAccountTransactionsDocument, options);
}
export const AuthoriseBatchPaymentMutationDocument = gql `
    mutation authoriseBatchPaymentMutation($input: AuthoriseBatchPaymentsInput!) {
  authoriseBatchPayment(input: $input) {
    Code
    clientMutationId
    Message
    Success
  }
}
    `;
export const AuthoriseBatchPaymentMutationComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: AuthoriseBatchPaymentMutationDocument, ...props }));
export function withAuthoriseBatchPaymentMutation(operationOptions) {
    return ApolloReactHoc.withMutation(AuthoriseBatchPaymentMutationDocument, {
        alias: 'authoriseBatchPaymentMutation',
        ...operationOptions
    });
}
;
/**
 * __useAuthoriseBatchPaymentMutationMutation__
 *
 * To run a mutation, you first call `useAuthoriseBatchPaymentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthoriseBatchPaymentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authoriseBatchPaymentMutationMutation, { data, loading, error }] = useAuthoriseBatchPaymentMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthoriseBatchPaymentMutationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AuthoriseBatchPaymentMutationDocument, options);
}
export const BatchPaymentDetailsByBatchPaymentDocument = gql `
    query batchPaymentDetailsByBatchPayment($input: BatchPaymentDetailsByBatchPaymentInput!) {
  batchPaymentDetails(input: $input) {
    BatchPaymentDetails {
      Id
      AccountNumber
      RemitterName
      BankIdentifier {
        BankIdentifier
        BankIdentifierType
        BankName
        Description
      }
      AccountName
      Indicator
      TransactionCode
      Amount {
        Amount
        CurrencyCode
      }
      LodgementReference
      WithholdingTax {
        Amount
        CurrencyCode
      }
    }
  }
}
    `;
export const BatchPaymentDetailsByBatchPaymentComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: BatchPaymentDetailsByBatchPaymentDocument, ...props }));
export function withBatchPaymentDetailsByBatchPayment(operationOptions) {
    return ApolloReactHoc.withQuery(BatchPaymentDetailsByBatchPaymentDocument, {
        alias: 'batchPaymentDetailsByBatchPayment',
        ...operationOptions
    });
}
;
/**
 * __useBatchPaymentDetailsByBatchPaymentQuery__
 *
 * To run a query within a React component, call `useBatchPaymentDetailsByBatchPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchPaymentDetailsByBatchPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchPaymentDetailsByBatchPaymentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchPaymentDetailsByBatchPaymentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(BatchPaymentDetailsByBatchPaymentDocument, options);
}
export function useBatchPaymentDetailsByBatchPaymentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(BatchPaymentDetailsByBatchPaymentDocument, options);
}
export function useBatchPaymentDetailsByBatchPaymentSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(BatchPaymentDetailsByBatchPaymentDocument, options);
}
export const BatchPaymentsByIdDocument = gql `
    query batchPaymentsById($input: BatchPaymentByIdInput!) {
  batchPaymentsById(input: $input) {
    Id
    Account {
      Id
      Number
    }
    Description
    ScheduledDate
    AuthorisedDate
    AuthorisedById
    AuthorisedByName
    Status
    Total {
      Amount
      CurrencyCode
    }
    PaymentsCount
  }
}
    `;
export const BatchPaymentsByIdComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: BatchPaymentsByIdDocument, ...props }));
export function withBatchPaymentsById(operationOptions) {
    return ApolloReactHoc.withQuery(BatchPaymentsByIdDocument, {
        alias: 'batchPaymentsById',
        ...operationOptions
    });
}
;
/**
 * __useBatchPaymentsByIdQuery__
 *
 * To run a query within a React component, call `useBatchPaymentsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchPaymentsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchPaymentsByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchPaymentsByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(BatchPaymentsByIdDocument, options);
}
export function useBatchPaymentsByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(BatchPaymentsByIdDocument, options);
}
export function useBatchPaymentsByIdSuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(BatchPaymentsByIdDocument, options);
}
export const BatchPaymentsByPartyDocument = gql `
    query batchPaymentsByParty {
  batchPaymentsByParty {
    Id
    Account {
      Number
    }
    Description
    ScheduledDate
    AuthorisedDate
    AuthorisedById
    Status
    Total {
      Amount
      CurrencyCode
    }
    PaymentsCount
  }
}
    `;
export const BatchPaymentsByPartyComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: BatchPaymentsByPartyDocument, ...props }));
export function withBatchPaymentsByParty(operationOptions) {
    return ApolloReactHoc.withQuery(BatchPaymentsByPartyDocument, {
        alias: 'batchPaymentsByParty',
        ...operationOptions
    });
}
;
/**
 * __useBatchPaymentsByPartyQuery__
 *
 * To run a query within a React component, call `useBatchPaymentsByPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchPaymentsByPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchPaymentsByPartyQuery({
 *   variables: {
 *   },
 * });
 */
export function useBatchPaymentsByPartyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(BatchPaymentsByPartyDocument, options);
}
export function useBatchPaymentsByPartyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(BatchPaymentsByPartyDocument, options);
}
export function useBatchPaymentsByPartySuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(BatchPaymentsByPartyDocument, options);
}
export const DeleteBatchPaymentMutationDocument = gql `
    mutation deleteBatchPaymentMutation($input: DeleteBatchPaymentInput!) {
  deleteBatchPayment(input: $input) {
    Code
    Success
  }
}
    `;
export const DeleteBatchPaymentMutationComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: DeleteBatchPaymentMutationDocument, ...props }));
export function withDeleteBatchPaymentMutation(operationOptions) {
    return ApolloReactHoc.withMutation(DeleteBatchPaymentMutationDocument, {
        alias: 'deleteBatchPaymentMutation',
        ...operationOptions
    });
}
;
/**
 * __useDeleteBatchPaymentMutationMutation__
 *
 * To run a mutation, you first call `useDeleteBatchPaymentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBatchPaymentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBatchPaymentMutationMutation, { data, loading, error }] = useDeleteBatchPaymentMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBatchPaymentMutationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteBatchPaymentMutationDocument, options);
}
export const TransferAccountsByPartyDocument = gql `
    query transferAccountsByParty {
  transferAccountsByParty {
    AccountId
    AccountCategory
    AccountName
    AccountNumber
    BSB
    BillerCode
    RedrawBalance
    IsBankAccount
    IsExternal
    IsBPay
    InstrumentId
    AllowRead
    AllowOperate
    AllowInterAccount
    AllowDirectDebit
    AllowBPay
    AllowRedraw
    AllowPayAnyone
    CapitalAccountNumber
    IsDirectDebit
    IsDirectCredit
    FunderAllowsNPP
    AccountIsValidForNPP
    MinimumDirectDebitDate
    LinkedInstrumentsAccounts
    AllowInterInstrument
    Status
    BlockIncomingTransfers
    BlockOutgoingTransfers
  }
}
    `;
export const TransferAccountsByPartyComponent = (props) => (_jsx(ApolloReactComponents.Query, { query: TransferAccountsByPartyDocument, ...props }));
export function withTransferAccountsByParty(operationOptions) {
    return ApolloReactHoc.withQuery(TransferAccountsByPartyDocument, {
        alias: 'transferAccountsByParty',
        ...operationOptions
    });
}
;
/**
 * __useTransferAccountsByPartyQuery__
 *
 * To run a query within a React component, call `useTransferAccountsByPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferAccountsByPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferAccountsByPartyQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransferAccountsByPartyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(TransferAccountsByPartyDocument, options);
}
export function useTransferAccountsByPartyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(TransferAccountsByPartyDocument, options);
}
export function useTransferAccountsByPartySuspenseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(TransferAccountsByPartyDocument, options);
}
export const UpdateBatchPaymentMutationDocument = gql `
    mutation updateBatchPaymentMutation($input: UpdateBatchPaymentInput!) {
  updateBatchPayment(input: $input) {
    Code
    clientMutationId
    Message
    Success
  }
}
    `;
export const UpdateBatchPaymentMutationComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: UpdateBatchPaymentMutationDocument, ...props }));
export function withUpdateBatchPaymentMutation(operationOptions) {
    return ApolloReactHoc.withMutation(UpdateBatchPaymentMutationDocument, {
        alias: 'updateBatchPaymentMutation',
        ...operationOptions
    });
}
;
/**
 * __useUpdateBatchPaymentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateBatchPaymentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBatchPaymentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBatchPaymentMutationMutation, { data, loading, error }] = useUpdateBatchPaymentMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBatchPaymentMutationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateBatchPaymentMutationDocument, options);
}
export const UploadAbaBatchPaymentFileDocument = gql `
    mutation uploadABABatchPaymentFile($input: ABABatchPaymentFileInput!) {
  aBABatchPaymentFile(input: $input) {
    Code
    clientMutationId
    Message
    Success
    BatchPaymentId
  }
}
    `;
export const UploadAbaBatchPaymentFileComponent = (props) => (_jsx(ApolloReactComponents.Mutation, { mutation: UploadAbaBatchPaymentFileDocument, ...props }));
export function withUploadAbaBatchPaymentFile(operationOptions) {
    return ApolloReactHoc.withMutation(UploadAbaBatchPaymentFileDocument, {
        alias: 'uploadAbaBatchPaymentFile',
        ...operationOptions
    });
}
;
/**
 * __useUploadAbaBatchPaymentFileMutation__
 *
 * To run a mutation, you first call `useUploadAbaBatchPaymentFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAbaBatchPaymentFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAbaBatchPaymentFileMutation, { data, loading, error }] = useUploadAbaBatchPaymentFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAbaBatchPaymentFileMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UploadAbaBatchPaymentFileDocument, options);
}
